import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './styles/globals.css';

/**
 * MSAL acquireTokenSilent이 생성한 hidden iframe 내부인지 감지.
 * iframe 안에서 앱이 다시 렌더링되면 block_iframe_reload / timed_out 에러 발생.
 * Teams iframe은 cross-origin이라 frameElement === null → false 반환.
 */
function isInMsalHiddenIframe(): boolean {
  if (window === window.parent) return false;
  try {
    const frame = window.frameElement as HTMLElement | null;
    return frame?.style.visibility === 'hidden';
  } catch {
    return false;
  }
}

if (!isInMsalHiddenIframe()) {
  // 배포 후 이전 해시 chunk 로드 실패 시 자동 리로드
  const RELOAD_KEY = 'chunk-reload';
  if (sessionStorage.getItem(RELOAD_KEY)) {
    sessionStorage.removeItem(RELOAD_KEY);
  }
  window.addEventListener('vite:preloadError', () => {
    if (!sessionStorage.getItem(RELOAD_KEY)) {
      sessionStorage.setItem(RELOAD_KEY, '1');
      window.location.reload();
    }
  });

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
